module.exports = __webpack_public_path__ + "img/set_theme_12.ebb62917.png";